import { render } from "./issueTrustForm.vue?vue&type=template&id=22b8a49e&scoped=true"
import script from "./issueTrustForm.vue?vue&type=script&lang=js"
export * from "./issueTrustForm.vue?vue&type=script&lang=js"

import "./issueTrustForm.vue?vue&type=style&index=0&id=22b8a49e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b8a49e"]])

export default __exports__